import { useEffect, useRef, useState } from 'react';
import ApiDatabase from 'server';

/**
 * The month's invoices to fix, read when the journal opens (JBWEB-1280), then
 * again each time `refreshKey` changes (a run starting or ending). Once
 * something is shown, a new read never blanks it: neither while it loads, nor
 * when it fails.
 */
const useInvoiceImportErrors = (period, refreshKey) => {
  const [state, setState] = useState({ status: 'loading', data: null });
  const [attempt, setAttempt] = useState(0);
  const hasData = useRef(false);

  useEffect(() => {
    let active = true;
    if (!hasData.current) setState({ status: 'loading', data: null });
    ApiDatabase.getInvoiceImportErrors(
      { period },
      (data) => {
        if (!active) return;
        hasData.current = true;
        setState({ status: 'ready', data });
      },
      (error) => {
        if (!active || error?.name === 'CanceledError') return;
        if (hasData.current) return;
        setState({ status: 'failed', data: null });
      },
    );
    return () => {
      active = false;
    };
  }, [period, refreshKey, attempt]);

  return { ...state, reload: () => setAttempt((count) => count + 1) };
};

export default useInvoiceImportErrors;
